import { EditOutlined } from '@ant-design/icons';
import Link from '@arivaa-react/components/link';
import { Button, Tooltip } from 'antd';
import { translate } from '../../../../localization';
import { url } from '../../../../constants/api';
import { useWebsiteInfo } from '../useWebsiteInfo';
import { getAuthData } from '../../../../hooks/useAuth';

export function EditPageAction({ pageKey }) {
  const { websiteId, websiteUrl } = useWebsiteInfo();
  return (
    <a
      onClick={() => {
        const saveUrl = `${window.location.origin}${url(
          `website-configurations/${websiteId}/save`
        )}`;
        // Pass a url to save changes with access token and website Id and remove this whole dependency of message
        // In future we will issue a unique token for editing that expires after
        // a certain amount of activity
        window.open(
          `${websiteUrl}/${pageKey}?_editToken=${btoa(saveUrl)}&authorization=${getAuthData()?.accessToken}`,
          '_blank'
        );
      }}
    >
      <Tooltip placement="top" title={translate('crud.edit')}>
        <Button className="edit">
          <EditOutlined />
        </Button>
      </Tooltip>
    </a>
  );
}

export function EditPageAction2({ pageKey }) {
  return (
    <Link routeKey="home.website.page" routeParams={{ key: pageKey }}>
      <Tooltip placement="top" title={translate('crud.edit')}>
        <Button className="edit">
          <EditOutlined />
        </Button>
      </Tooltip>
    </Link>
  );
}
